import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class AzureNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Azure';
        this.id = 'node_azure';
        this.linkedFeature = 'azure';
        this.requirements = ['azure'];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        let links = project.getNodeLinks(this, 'azure_connect');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    azure_start(AZURE_DEVICE_ID,AZURE_SCOPE_ID,AZURE_DPS_SERVER,AZURE_PRIMARY_KEY,AZURE_INTERFACE_SELECTED)`,
            });
        }

        links = project.getNodeLinks(this, 'azure_disconnect');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    mqtt_disconnect()`,
            });
        }

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev_demo_03';
    }
}
